// Metadata for the two legal pages. Kept as pure data (no JSX) so the
// "Privacy Policy and Terms of Service are SEPARATE pages that link to
// each other" invariant — a TikTok Login-Kit production-review
// requirement — is unit-testable without rendering.
//
// TikTok review rejected the app when both URLs pointed at one combined
// /privacy page ("Terms of Service and Privacy Policy cannot be on the
// same page"). These constants pin: distinct titles, distinct paths,
// and each page cross-linking the OTHER one.

export const LEGAL = {
  privacy: {
    key: 'privacy',
    title: 'Privacy Policy',
    path: '/privacy',
    other: { label: 'Terms of Service', href: '/terms' },
  },
  terms: {
    key: 'terms',
    title: 'Terms of Service',
    path: '/terms',
    other: { label: 'Privacy Policy', href: '/privacy' },
  },
};

// Display date for "Last updated" — bump when the policy text changes.
export const LEGAL_LAST_UPDATED = 'June 11, 2026';

export default LEGAL;
